<div [ngClass]="{ done: file?.progress === 100 }" class="file-item">
    <ca-icon
        *ngIf="file?.progress !== 100"
        name="loading"
        size="s"
        class="d-flex h-100 align-items-center upload-spinner"
        data-uit="file-upload-loader"
    ></ca-icon>
    <ca-icon *ngIf="file?.progress === 100" name="checkmark" size="s" class="ca-color-success success-checkmark" data-uit="success-checkmark"></ca-icon>
    <span
        class="file-name ms-2 me-2 text-truncate"
        [ngClass]="{ 'text-highlight': file?.progress === 100 }"
        [title]="file?.file?.name"
        ngbTooltip="{{ file?.file?.name }}"
        container="body"
        placement="top"
    >
        {{ file?.file?.name }}
    </span>
    <span *ngIf="!file?.isUploaded" [ngClass]="{ hide: file?.progress === 100 }">
        {{ file?.progress | percentage }}
    </span>
    <button
        data-uit="cancel-file-upload"
        type="button"
        class="btn ca-btn-icon cancel-btn"
        (click)="cancelFileUpload.emit(file)"
        [title]="'GENERAL.CANCEL' | translate"
    >
        <ca-icon name="cross" size="s" [title]="'GENERAL.CANCEL' | translate"></ca-icon>
    </button>
</div>
<div class="progress-bar-panel">
    <div role="progressbar" [ngStyle]="{ width: file?.progress + '%' }" class="progress-bar"></div>
</div>
